import type { FaireProductEntity } from "../../entity_types/product";

export const p_h3ssyzq8bs: FaireProductEntity = {
  token: "p_h3ssyzq8bs",
  type: "product",
  name: "Peanut Shaped Flour Squishy",
  brandToken: "b_bya786doke",
  brandName: "Love and Repeat",
  imageUrl:
    "https://cdn.faire.com/fastly/410aa95eb7728c3957f3627e694029a94bd5a52431f5a4ac38994517a4ff9595.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e27029985c04793f1b4af71282f1dea304bfce2c9b8f589c009128e9d03d5e3e.jpeg",
    "https://cdn.faire.com/fastly/01812af9dcc4e257d25dd52987245bf11687eca072afef29975e58255ec0b1d7.jpeg",
    "https://cdn.faire.com/fastly/b85e813d4494cc621f4ffbf895683547ac8c341ec0dcdb50b05c2057212165ca.jpeg",
    "https://cdn.faire.com/fastly/0cd4fd9fdf3c3cd836b5d01b319cbb71f079c0458d6450985c8b47e9fa3318d6.jpeg",
    "https://cdn.faire.com/fastly/8300cc0c271f6febe56576b6e0906b41da8d8c6932ec4d8b631e0b4ccaa0b026.jpeg",
    "https://cdn.faire.com/fastly/1025d672eaad3d7255723052ef8a36e6a696ca83b5ba126eb8f8cb0eb0309e8b.jpeg",
    "https://cdn.faire.com/fastly/c16a8d90cb67cbddb35a75cbd47b93b4731ff1d26b7d3862dacf186f12a295f1.jpeg",
  ],
  priceDollars: 2.5,
  description:
    "Peanut Shaped Flour Squishy\r\n\r\n-Peanut Shaped Food Squishies, Soft Squeeze Toy, Cute Peanut Squishy Toy for Stress Relief, Desk Decor, Office Breaks, Party Favors, Goodie Bags, Stocking Stuffers, Novelty Gift\r\n-Very satisfying Sound\r\n-4 Inch Long\r\n",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:38.751Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
